'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');
var styled = require('styled-components');
var HalfCard = require('@swiggy-private/dls-web-core/dist/components/HalfCard');
var AddButton$2 = require('@swiggy-private/dls-web-core/dist/components/AddButton');
var components_FoodItem_types = require('../FoodItem/types.js');
var Customise = require('../../Customise-Iyr7KqY2.js');
var CustomisePrompt = require('../../CustomisePrompt-BEky4xtR.js');
var CustomizeContext = require('../../CustomizeContext-CpkrEQ6Z.js');
var Portal = require('@swiggy-private/dls-web-core/dist/components/Portal');
var Toast$2 = require('@swiggy-private/dls-web-recipe-food-web/dist/components/Toast');
var utils = require('../../utils-CqsSjtb2.js');
require('../../Header-wk4mHKME.js');
require('../../BasicInfo-DwD6dQA0.js');
require('@swiggy-private/dls-web-core/dist/components/Text');
require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
require('@swiggy-private/dls-web-core/dist/components/RadioGroup');
require('@swiggy-private/dls-web-core/dist/components/Button');
require('@swiggy-private/dls-web-core/dist/components/CardContainer');
require('../Customise/constants/index.js');
require('@swiggy-private/dls-web-core/dist/components/Checkbox');
require('../../PartialList-Cdl4XIGT.js');
require('../../ScreenReaderOnly-Bo2uWdwZ.js');
require('../../_tslib-D25eJ2i9.js');
require('../../PriceV4-CAdVMHnO.js');
require('../../index-2bhV6eMA.js');
require('../Customise/CustomizeContext/types.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const NextAvailableMsg = styled__default.default.div(({ theme }) => ({
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    borderRadius: theme.cornerRadius.xxSmall,
    background: "#fff",
    fontWeight: 400,
    fontSize: "9px",
    padding: "3px 7px",
    textAlign: "center",
    color: "rgba(2, 6, 12, 0.6)",
    position: "absolute",
    width: "96px",
    minHeight: "36px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));
const ToastContainer = styled__default.default.div(({ positionFromBottom, theme }) => ({
    position: "fixed",
    bottom: positionFromBottom || 0,
    zIndex: 402,
    contain: "content",
    overflow: "hidden",
    margin: `0 ${theme.spacing.xxLarge}`,
    left: 0,
    right: 0,
    "& > div": {
        position: "relative",
    },
}));

const getVariantsNew = (item) => jsUtils.getNestedValue(item, "variants_new.variant_groups");
const getVariantsV2 = (item) => {
    return (jsUtils.getNestedValue(item, "variantsV2.variant_groups") ||
        jsUtils.getNestedValue(item, "variantsV2.variantGroups"));
};
const getAddons = (item) => {
    const addons = !jsUtils.isEmpty(item.addons) ? item.addons : [];
    return addons;
};
const isItemCustomizable = (item) => {
    return (!jsUtils.isEmpty(getVariantsNew(item)) || !jsUtils.isEmpty(getVariantsV2(item)) || !jsUtils.isEmpty(getAddons(item)));
};
const getUnavailableText = (item) => {
    let unavailableTextMsg = "";
    if (!jsUtils.isEmpty(item === null || item === void 0 ? void 0 : item.nextAvailableAtMessage)) {
        unavailableTextMsg = item === null || item === void 0 ? void 0 : item.nextAvailableAtMessage;
    }
    else if ((item === null || item === void 0 ? void 0 : item.inStock) === 0 && (item === null || item === void 0 ? void 0 : item.outOfStockMessage) !== undefined) {
        unavailableTextMsg = item === null || item === void 0 ? void 0 : item.outOfStockMessage;
    }
    return unavailableTextMsg;
};

const TEXTS = {
    REPLACE_CART_ITEM: "Replace Items already in the cart",
    SOMETHING_WENT_WRONG: "Opps!! Something went wrong. Please try again.",
    CUSTOMISATION_HELPER_TEXT: "Customisable",
};

const AddButton = (props) => {
    const { item, buttonSize, updating, isCustomizable, quantity, onQuantityChange, hideItemOverlay, } = props;
    const incQuantity = React.useCallback(() => {
        if (updating)
            return;
        if (isCustomizable) {
            onQuantityChange(quantity + 1);
        }
        else {
            hideItemOverlay === null || hideItemOverlay === void 0 ? void 0 : hideItemOverlay(components_FoodItem_types.HideOverlayBottonType.RIGHT);
            onQuantityChange(Math.max(quantity + 1, 0));
        }
    }, [isCustomizable, hideItemOverlay, onQuantityChange, quantity, updating]);
    const decQuantity = React.useCallback(() => {
        if (updating)
            return;
        if (isCustomizable) {
            onQuantityChange(Math.max(quantity - 1, 0));
        }
        else {
            hideItemOverlay === null || hideItemOverlay === void 0 ? void 0 : hideItemOverlay(components_FoodItem_types.HideOverlayBottonType.LEFT);
            onQuantityChange(Math.max(quantity - 1, 0));
        }
    }, [isCustomizable, hideItemOverlay, onQuantityChange, quantity, updating]);
    const unavailableText = React.useMemo(() => getUnavailableText(item), [item]);
    const helperText = React.useMemo(() => {
        return props.isCustomizable && jsUtils.isEmpty(unavailableText)
            ? TEXTS.CUSTOMISATION_HELPER_TEXT
            : undefined;
    }, [props.isCustomizable, unavailableText]);
    return (React__default.default.createElement(AddButton$2.AddButton, { size: buttonSize === "small" ? "small" : "normal", value: quantity, onClickDecrement: decQuantity, onClickIncrement: incQuantity, helperText: helperText, isUnavailable: !jsUtils.isEmpty(unavailableText), unavailableText: unavailableText, updating: updating }));
};
var AddButton$1 = React__default.default.memo(AddButton);

var ToastStatus;
(function (ToastStatus) {
    ToastStatus["HIDDEN"] = "hidden";
    ToastStatus["VISIBLE"] = "visible";
})(ToastStatus || (ToastStatus = {}));
const Toast = ({ toast, onDismiss }) => {
    if (toast.status === ToastStatus.HIDDEN) {
        return null;
    }
    return (React__default.default.createElement(Portal.Portal, null,
        React__default.default.createElement(ToastContainer, { positionFromBottom: toast.positionFromBottom },
            React__default.default.createElement(Toast$2.Toast, { message: toast.text, show: toast.status === ToastStatus.VISIBLE, autoDismiss: true, onDismiss: onDismiss }))));
};
var Toast$1 = React.memo(Toast);

const AddButtonWrapper = (props) => {
    const defaultCartItem = { itemId: 0, items: [], quantity: 0 };
    const cartItem = props.cartItem || defaultCartItem;
    const [quantity, setQuantity] = React.useState(cartItem.quantity);
    const [showToastErrMsg, updateShowToastErrMsg] = React.useState("");
    const [showCustimisedItemPrompt, updateShowCustimisedItemPrompt] = React.useState(false);
    const [updating, setUpdating] = React.useState(false);
    const [showCustomizeBS, setShowCustomizeBS] = React.useState(false);
    const { dispatch } = React.useContext(CustomizeContext.CustomizeContext);
    const isCustomizable = isItemCustomizable(props.item);
    const getLastCartItem = React.useCallback(() => {
        return cartItem.items.length > 0 ? cartItem.items[cartItem.items.length - 1] : null;
    }, [cartItem.items]);
    const openCustomize = React.useCallback((ignorePrompt = false, repeatFlow = false) => {
        var _a, _b;
        if (repeatFlow)
            updateShowCustimisedItemPrompt(false);
        if (!ignorePrompt) {
            if (props.hideItemOverlay) {
                (_a = props.hideItemOverlay) === null || _a === void 0 ? void 0 : _a.call(props, components_FoodItem_types.HideOverlayBottonType.RIGHT);
            }
        }
        dispatch(Customise.showCustomizeModal(props.item, false, repeatFlow));
        if (props.hideItemOverlay) {
            (_b = props.hideItemOverlay) === null || _b === void 0 ? void 0 : _b.call(props, components_FoodItem_types.HideOverlayBottonType.RIGHT);
            return;
        }
        setShowCustomizeBS(true);
    }, [dispatch, props]);
    const onUpdateItemFailure = React.useCallback((errorMessage = TEXTS.SOMETHING_WENT_WRONG) => {
        setQuantity(cartItem.quantity);
        updateShowToastErrMsg(errorMessage);
    }, [cartItem.quantity]);
    const removeErrMsg = () => updateShowToastErrMsg("");
    const updateItem = React.useCallback((item) => {
        return props
            .updateItem(item)
            .then((success) => (success ? Promise.resolve() : Promise.reject()))
            .catch(onUpdateItemFailure)
            .then(() => setUpdating(false));
    }, [onUpdateItemFailure, props]);
    const getNewItemForUpdate = React.useCallback((qua, itemData) => {
        var _a;
        if (!jsUtils.isEmpty(itemData)) {
            return Object.assign(Object.assign({}, itemData), { quantity: qua });
        }
        return {
            quantity: qua,
            addons: [],
            menu_item_id: props.item.id,
            menu_item_uuid: utils.generateUUID((_a = props === null || props === void 0 ? void 0 : props.item) === null || _a === void 0 ? void 0 : _a.id, [], []),
            variants: [],
        };
    }, [props.item.id]);
    const changeItemQuantity = React.useCallback((newQuantity, newItem) => {
        setUpdating(true);
        updateShowCustimisedItemPrompt(false);
        return updateItem(jsUtils.isEmpty(newItem) ? getNewItemForUpdate(newQuantity) : newItem);
    }, [getNewItemForUpdate, updateItem]);
    const handleCustomizeItemQuantityChange = React.useCallback((updatedQuantity, repeatFlow = false) => {
        var _a, _b;
        let change = updatedQuantity - quantity;
        const lastCartItem = getLastCartItem();
        if (repeatFlow) {
            change = updatedQuantity - (lastCartItem ? lastCartItem.quantity : 0);
        }
        const newQuantity = lastCartItem !== null ? lastCartItem.quantity + change : change;
        const newItem = getNewItemForUpdate(newQuantity, lastCartItem || undefined);
        if (lastCartItem === null) {
            return openCustomize();
        }
        if (change > 0 && !repeatFlow) {
            if (props.hideItemOverlay) {
                (_a = props.hideItemOverlay) === null || _a === void 0 ? void 0 : _a.call(props, components_FoodItem_types.HideOverlayBottonType.RIGHT);
                return;
            }
            updateShowCustimisedItemPrompt(true);
        }
        else {
            if (props.hideItemOverlay) {
                (_b = props.hideItemOverlay) === null || _b === void 0 ? void 0 : _b.call(props, components_FoodItem_types.HideOverlayBottonType.LEFT);
                return;
            }
            changeItemQuantity(newItem.quantity, newItem);
        }
    }, [changeItemQuantity, getLastCartItem, getNewItemForUpdate, openCustomize, props, quantity]);
    const doQuantityChange = (q) => changeItemQuantity(q);
    const tryQuantityChange = (nQuan) => {
        if (updating || quantity === nQuan) {
            return;
        }
        if (nQuan !== quantity && isCustomizable) {
            return handleCustomizeItemQuantityChange(nQuan);
        }
        doQuantityChange(nQuan);
    };
    const closeCustomize = () => {
        setShowCustomizeBS(false);
    };
    const confirmCustomisePrompt = React.useCallback(() => {
        var _a;
        handleCustomizeItemQuantityChange((((_a = getLastCartItem()) === null || _a === void 0 ? void 0 : _a.quantity) || 0) + 1, true);
    }, [getLastCartItem, handleCustomizeItemQuantityChange]);
    const rejectCustomisePrompt = React.useCallback(() => {
        openCustomize(false, true);
    }, [openCustomize]);
    React__default.default.useEffect(() => {
        setQuantity(cartItem.quantity);
    }, [cartItem.quantity]);
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(AddButton$1, { item: props.item, quantity: quantity, updating: updating, onQuantityChange: tryQuantityChange, isCustomizable: isCustomizable }),
        React__default.default.createElement(HalfCard.HalfCard, { isOpen: showCustomizeBS, onClose: closeCustomize, hasCustomPadding: true, overflowY: "hidden" },
            React__default.default.createElement(Customise.Customize, { backgroundColor: props.backgroundColor, closeCustomize: closeCustomize, item: props.item, showToast: onUpdateItemFailure, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem })),
        React__default.default.createElement(Toast$1, { toast: {
                text: showToastErrMsg,
                positionFromBottom: 96,
                status: showToastErrMsg ? ToastStatus.VISIBLE : ToastStatus.HIDDEN,
            }, onDismiss: removeErrMsg }),
        React__default.default.createElement(CustomisePrompt.CustomisePrompt, { showPrompt: showCustimisedItemPrompt, confirm: confirmCustomisePrompt, reject: rejectCustomisePrompt })));
};
var AddButtonWrapper$1 = React__default.default.memo(AddButtonWrapper);

const RenderAddButton = (item, canAddItem, additionalProps) => {
    const getMessage = React__default.default.useMemo(() => {
        let msg = "";
        if (item.nextAvailableAtMessage) {
            msg = item.nextAvailableAtMessage;
        }
        else if (item.inStock !== 1 && item.outOfStockMessage !== undefined) {
            msg = item.outOfStockMessage;
        }
        return msg;
    }, [item]);
    if (!canAddItem) {
        return null;
    }
    if (!jsUtils.isEmpty(getMessage)) {
        return React__default.default.createElement(NextAvailableMsg, null, getMessage);
    }
    if (!jsUtils.isEmpty(item.variants)) {
        item.variants_new = Object.assign(Object.assign({}, item.variants), { variant_groups: item.variants.variantGroups || [] });
    }
    return (React__default.default.createElement(AddButtonWrapper$1, { item: item, updateItem: additionalProps.updateItem, cartItem: additionalProps.cartItem, addCustomizeItem: additionalProps.addCustomizeItem, updateCustomizeItem: additionalProps.updateCustomizeItem, hideItemOverlay: additionalProps.hideItemOverlay, backgroundColor: additionalProps.backgroundColor }));
};

exports.RenderAddItem = RenderAddButton;
exports.default = RenderAddButton;
//# sourceMappingURL=index.js.map
